import { types } from "react-bricks/frontend";

type ShowFn = (props: Record<string, any>) => boolean;

const makeColorProp = (name: string, label: string, show?: ShowFn) => ({
  name,
  label,
  type: types.SideEditPropType.Text,
  shouldRefreshStyles: true,
  ...(show && { show }),
});

export const backgroundColorProp = makeColorProp("backgroundColor", "Background Color");
export const titleColorProp = makeColorProp("titleColor", "Title Color");
export const textColorProp = makeColorProp("textColor", "Text Color");
export const linkColorProp = makeColorProp("linkColor", "Link Color");
export const eyebrowColorProp = makeColorProp(
  "eyebrowColor",
  "Eyebrow Color",
  (props) => props.showEyebrow,
);
